
import img1 from '../../../../Assets/Images/AboutUs/marquee/1.png';
import img2 from '../../../../Assets/Images/AboutUs/marquee/2.png';
import img3 from '../../../../Assets/Images/AboutUs/marquee/3.png';
import img4 from '../../../../Assets/Images/AboutUs/marquee/4.png';
import img5 from '../../../../Assets/Images/AboutUs/marquee/5.png';
import img6 from '../../../../Assets/Images/AboutUs/marquee/6.png';
import img7 from '../../../../Assets/Images/AboutUs/marquee/7.png';
import Marquee from "react-fast-marquee";
import { Container, Image } from "react-bootstrap";



const WorksMarquee = () => {

    const images =[
        {image:img1},
        {image:img2},
        {image:img3},
        {image:img4},
        {image:img5},
        {image:img6},
        {image:img7},
    ]
  return (
   
      <Container fluid className='my-5'>
        <Marquee direction='right' speed={40} pauseOnHover={true}>
          {images.map((image, index) => (
            <Image
               key={index}
               src={image.image}
               className='mx-4'
            />
          ))}
        </Marquee>
      </Container>
   
  );
};

export default WorksMarquee;
